var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-provider',_vm._b({attrs:{"multiple":""},model:{value:(_vm.providers),callback:function ($$v) {_vm.providers=$$v},expression:"providers"}},'select-provider',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }